<template>
    <div class="keep-watching-card">
        <img class="keep-watching-card__img" :src="image" alt="" />
        <div class="keep-watching-card__content">
            <h3 class="keep-watching-card__title">{{ truncatedTitle }}</h3>
            <p
                v-if="description"
                class="keep-watching-card__description"
            >
                {{ description }}
            </p>
            <a class="keep-watching-card__btn" :href="courseHref">
                <i class="pi pi-play" aria-hidden="true"></i>
                <span>{{ $t('student.keepWatching.continueFromWhere') }}</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'KeepWatchingCard',
        computed: {
            courseHref() {
                if (!this.id) return '#';
                return `/aluno/curso/${encodeURIComponent(this.id)}`;
            },
        },
        props: {
            id: {
                type: String,
                required: true,
            },
            image: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
        },
        computed: {
            truncatedTitle() {
                const title = this.title || this.$t('student.keepWatching.defaultTitle');
                if (title.length > 80) {
                    return title.slice(0, 80) + '...';
                }
                return title;
            },
        },
        data() {
            return {
                // Define any data properties if needed
            };
        },
    };
</script>

<style scoped>
    .keep-watching-card {
        width: 100%;
        background-color: #FFFFFF;
        overflow: hidden;
        border-radius: 12px;
        border: 1px solid #E4E7EC;
        box-shadow: none;
        display: flex;
        flex-direction: column;
    }

    .dark .keep-watching-card {
        background-color: #1a191f !important;
        border-color: rgba(255, 255, 255, 0.08) !important;
    }

    .keep-watching-card__img {
        width: 100%;
        height: auto;
        aspect-ratio: 16 / 9;
        max-height: 200px;
        object-fit: cover;
        display: block;
        background: #0a0a0b;
    }

    .keep-watching-card__content {
        padding: 16px;
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .keep-watching-card__title {
        font-size: 1.0625rem;
        font-weight: 700;
        line-height: 1.35;
        color: #1F2937;
        margin: 0 0 8px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .dark .keep-watching-card__title {
        color: #f2f4f8;
    }

    .keep-watching-card__description {
        font-size: 0.875rem;
        line-height: 1.5;
        color: #667085;
        margin: 0 0 14px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .dark .keep-watching-card__description {
        color: #9aa3b2 !important;
    }

    .keep-watching-card__btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 44px;
        padding: 12px 18px;
        background: #1ac4cd;
        color: #0f172a;
        text-decoration: none;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.875rem;
        transition: filter 0.2s, background 0.2s;
        cursor: pointer;
        box-shadow: none;
        width: 100%;
        box-sizing: border-box;
    }

    .dark .keep-watching-card__btn {
        color: #0f172a;
    }

    .keep-watching-card__btn:hover {
        filter: brightness(1.05);
    }

    .keep-watching-card__btn:focus-visible {
        outline: 2px solid #1ac4cd;
        outline-offset: 2px;
    }

    @media screen and (min-width: 960px) {
        .keep-watching-card {
            flex-direction: row;
            align-items: stretch;
        }

        .keep-watching-card__img {
            order: 2;
            width: 42%;
            max-height: none;
            height: auto;
            min-height: 220px;
            aspect-ratio: auto;
            align-self: stretch;
        }

        .keep-watching-card__content {
            order: 1;
            width: 58%;
            padding: 28px 32px;
            justify-content: center;
        }

        .keep-watching-card__title {
            font-size: 1.5rem;
            margin-bottom: 12px;
        }

        .keep-watching-card__description {
            -webkit-line-clamp: 3;
            line-clamp: 3;
            margin-bottom: 18px;
        }

        .keep-watching-card__btn {
            width: auto;
            align-self: flex-start;
        }
    }
</style>
